import { SummarizedWorkOrder } from '@mfe/shared/schema-types';

import { WorkOrderTypes } from './types';

export const filterByWorkOrderType = (
  data: SummarizedWorkOrder[] | null | undefined,
  workOrderTypes: string[]
) =>
  data?.filter((workOrder) =>
    workOrderTypes.includes(workOrder?.workOrderType)
  ) ?? [];

export const filterServiceCallWorkOrders = (
  workOrders: SummarizedWorkOrder[]
) => {
  return workOrders.filter(
    (workOrder) =>
      ![
        WorkOrderTypes.COMMERCIAL_INSTALL,
        WorkOrderTypes.INSTALL,
        WorkOrderTypes.UPGRADE,
      ].includes(workOrder.workOrderType as WorkOrderTypes)
  );
};
